import Cookie from 'js-cookie';
import { requestService } from 'services/api/utils';
import { WITH_COURIER } from 'enums/order-state-enums';

export function getHeaders() {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': Cookie.get('csrf'),
  };
}

export const getListOfPTs = (page = 1) => {
  return requestService('/api/v1/store_product_templates', {
    method: 'get',
    headers: getHeaders(),
    params: {
      includeMetadata: true,
      includeTotalCount: true,
      page: page,
    },
  }).then((response) => {
    return response;
  });
};

export const getProductVariants = (ptId) => {
  return requestService(`/api/v1/store_product_templates/${ptId}/product_variants`, {
    method: 'get',
    headers: getHeaders(),
    params: {},
  }).then((response) => {
    return response;
  });
};

export const getAllOpenOrders = (page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'dropship_open', page: page },
  }).then((response) => {
    return response;
  });
};

export const getNeedToConfirmOrders = (page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'to_confirm', page: page },
  }).then((response) => {
    return response;
  });
};

export function getNeedToShipOrders(page = 1) {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'dropship_need_to_ship', page: page },
  }).then((response) => {
    return response;
  });
}

export function getShippedOrders(page = 1) {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'dropship_seller_shipped', page: page },
  }).then((response) => {
    return response;
  });
}

export const getAllCompletedOrders = (page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'completed', page: page },
  }).then((response) => {
    return response;
  });
};

export const getDeliveredOrders = (page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'delivered', page: page },
  }).then((response) => {
    return response;
  });
};

export function getReturnedOrders(page = 1) {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'returned', page: page },
  }).then((response) => {
    return response;
  });
}

export function getCanceledOrders(page = 1) {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'canceled', page: page },
  }).then((response) => {
    return response;
  });
}

export function confirmOrder(number) {
  return requestService(`/api/v1/orders/${number}/update_status`, {
    method: 'PUT',
    headers: getHeaders(),
    credentials: 'include',
    body: JSON.stringify({
      order: {
        statusAction: 'seller_confirm',
      },
    }),
  }).then(() => {
    requestService(`/api/v1/orders/${number}/update_status`, {
      method: 'PUT',
      headers: getHeaders(),
      credentials: 'include',
      body: JSON.stringify({
        order: {
          statusAction: 'seller_packaging',
        },
      }),
    });
  });
}

export function cancelOrder(number, sellerCanceledReason) {
  return requestService(`/api/v1/orders/${number}/update_status`, {
    method: 'PUT',
    headers: getHeaders(),
    credentials: 'include',
    body: JSON.stringify({
      order: {
        statusAction: 'seller_cancel_review',
        sellerCanceledReason: sellerCanceledReason,
      },
    }),
  });
}

export function labelPrintedIndicator(number) {
  return requestService(`/api/v1/orders/${number}/update_status`, {
    method: 'PUT',
    headers: getHeaders(),
    credentials: 'include',
    body: JSON.stringify({
      order: {
        statusAction: WITH_COURIER,
      },
    }),
  });
}

export function updateProductPrice(storeProductTemplateId, priceCents) {
  return requestService(`/api/v1/store_product_templates/${storeProductTemplateId}`, {
    method: 'PUT',
    headers: getHeaders(),
    credentials: 'include',
    body: JSON.stringify({
      storeProductTemplate: {
        priceCents: priceCents,
      },
    }),
  });
}

export function resetToStorePrice(storeProductTemplateId) {
  return requestService(`/api/v1/store_product_templates/${storeProductTemplateId}`, {
    method: 'PUT',
    headers: getHeaders(),
    credentials: 'include',
    body: JSON.stringify({
      storeProductTemplate: {
        priceCents: null,
      },
    }),
  });
}
